// kfe-stat-card.js — large-number stat card (Brief 097).
//
// PORT TARGET: the big "148 Min" / "10.8%" stat presentation in the iOS
// KFELessonReportVC layout.
//
// Props:
//   value: string|number   the headline number
//   label: string          caption under the number
//   unit:  string           (optional, e.g. "Min", "%") rendered small next
//                           to the value
//
// Graceful degradation (Brief 097 success-criterion #13): when `value` is
// null / undefined / "" the card hides itself (`:host` collapses) so a parent
// section can leave the element in the tree and let it self-hide rather than
// branching markup. The host sets `hidden` so it occupies no layout box.

import { KFEComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class KFEStatCard extends KFEComponent {
  static props = ["value", "label", "unit"];
  static styles = `
    :host { display: block; }
    :host([hidden]) { display: none; }
    .card {
      text-align: center;
      padding: 1rem 0.5rem;
    }
    .value {
      color: var(--kfe-accent);
      font-size: 2.75rem; font-weight: 700; line-height: 1;
    }
    .unit {
      color: var(--kfe-accent);
      font-size: 1.1rem; font-weight: 600; margin-left: 0.25rem;
    }
    .label {
      color: var(--kfe-muted);
      font-size: 0.85rem; margin-top: 0.5rem;
    }
  `;

  render() {
    const value = /** @type {any} */ (this).value;
    const label = /** @type {string} */ (/** @type {any} */ (this).label ?? "");
    const unit = /** @type {string|undefined} */ (/** @type {any} */ (this).unit);

    const missing = value === null || value === undefined || value === "";
    // Self-hide on missing data so the parent can keep the element mounted.
    this.hidden = missing;
    if (missing) return html``;

    return html`
      <div class="card">
        <div>
          <span class="value">${value}</span>
          ${unit ? html`<span class="unit">${unit}</span>` : ""}
        </div>
        <div class="label">${label}</div>
      </div>
    `;
  }
}
